import { render, staticRenderFns } from "./MidwifeInfoDialog.vue?vue&type=template&id=3334bdf8"
import script from "./MidwifeInfoDialog.vue?vue&type=script&lang=js"
export * from "./MidwifeInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports